import { ENV } from '../../config/runtimeEnv';
import type { Subscription, SubscriptionPlan } from "../../types/admin/SubscriptionTypes";
import { http } from "../../lib/http/client";

const API_BASE_URL = ENV.VITE_HEALTHCARE_SERVER;

const getHeaders = () => ({
  "Content-Type": "application/json",
});


export const fetchCompanySubscriptionsPractitioner = async (companyId: number): Promise<Subscription[]> => {
  const res = await http.get(`${API_BASE_URL}/practitioner/companies/${companyId}/subscriptions`, { headers: getHeaders() });
  return res.data;
};

export const fetchCompanyAvailableRolesPractitioner = async (companyId: number): Promise<string[]> => {
  const res = await http.get(`${API_BASE_URL}/practitioner/companies/${companyId}/available-roles`, { headers: getHeaders() });
  return res.data;
};
